import { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import { Button } from "../components/ui/button";
import { Badge } from "../components/ui/badge";
import { API } from "../constants";
import { SEO } from "../components/SEO";

const BlogPost = () => {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchBlogPost();
  }, [slug]);

  const fetchBlogPost = async () => {
    try {
      const response = await axios.get(`${API}/blog/posts/${slug}`);
      setPost(response.data);
    } catch (error) {
      console.error('Error fetching blog post:', error);
      toast.error('Blog post not found');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="flex justify-center items-center h-64">Loading...</div>;
  }

  if (!post) {
    return <div className="text-center py-12">Blog post not found</div>;
  }

  return (
    <div className="max-w-4xl mx-auto px-4 py-12">
      <SEO
        title={post.title}
        description={post.excerpt || post.title}
        path={`/blog/${slug}`}
        image={post.featured_image}
        type="article"
      />
      <article>
        {post.featured_image && (
          <div className="aspect-video overflow-hidden rounded-xl mb-8">
            <img
              src={post.featured_image}
              alt={post.title}
              className="w-full h-full object-cover"
            />
          </div>
        )}
        
        <header className="mb-8">
          <div className="flex flex-wrap gap-2 mb-4">
            {post.tags.map(tag => (
              <Badge key={tag} variant="secondary">
                {tag}
              </Badge>
            ))}
          </div>
          
          <h1 className="text-4xl font-bold text-gray-900 mb-4">
            {post.title}
          </h1>
          
          <div className="flex items-center text-gray-600">
            <span>By {post.author}</span>
            <span className="mx-2">•</span>
            <span>{new Date(post.created_at).toLocaleDateString()}</span>
          </div>
        </header>

        <div className="prose prose-lg max-w-none">
          {post.content.split('\n').map((paragraph, index) => {
            const lineKey = `line-${index}`;
            if (paragraph.startsWith('# ')) {
              return <h1 key={lineKey} className="text-3xl font-bold mt-8 mb-4">{paragraph.slice(2)}</h1>;
            } else if (paragraph.startsWith('## ')) {
              return <h2 key={lineKey} className="text-2xl font-bold mt-6 mb-3">{paragraph.slice(3)}</h2>;
            } else if (paragraph.startsWith('### ')) {
              return <h3 key={lineKey} className="text-xl font-bold mt-4 mb-2">{paragraph.slice(4)}</h3>;
            } else if (paragraph.startsWith('**') && paragraph.endsWith('**')) {
              return <p key={lineKey} className="font-bold mb-4">{paragraph.slice(2, -2)}</p>;
            } else if (paragraph.trim() === '') {
              return null;
            } else {
              return <p key={lineKey} className="mb-4 text-gray-700 leading-relaxed">{paragraph}</p>;
            }
          })}
        </div>

        <div className="mt-12 pt-8 border-t">
          <div className="flex justify-center">
            <Button asChild>
              <Link to="/blog">← Back to Blog</Link>
            </Button>
          </div>
        </div>
      </article>
    </div>
  );
};

// Cart Component with Updated Display for New Embroidery System

export { BlogPost };
export default BlogPost;
